<template lang="pug">
div
  sharing-embed
  v-divider.basic500.my-5
  sharing-qr-code
  v-divider.basic500.my-5
  sharing-seo

</template>

<script>
import SharingEmbed from './SharingEmbed.vue'
import SharingQrCode from './SharingQrCode.vue'
import SharingSeo from './SharingSeo.vue'

export default {
  name: 'ManageSharing',
  components: { SharingEmbed, SharingQrCode, SharingSeo },
}
</script>

<style scoped>

</style>